import { create } from 'zustand';

type SaveStatus = 'idle' | 'saving' | 'saved' | 'error';

interface UIState {
    saveStatus: SaveStatus;
    lastSavedAt: Date | null;
    retrySaveTrigger: number;
    actions: {
        setSaveStatus: (status: SaveStatus) => void;
        triggerRetrySave: () => void;
    };
}

export const useUIStore = create<UIState>((set) => ({
    saveStatus: 'idle',
    lastSavedAt: null,
    retrySaveTrigger: 0,
    actions: {
        setSaveStatus: (status) => set((state) => ({
            saveStatus: status,
            lastSavedAt: status === 'saved' ? new Date() : state.lastSavedAt
        })),
        triggerRetrySave: () => set((state) => ({ retrySaveTrigger: Date.now() })),
    },
}));
